import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { CustomUrlGuard } from '@core/guards/custom-url.guard';
import { PermissionsGuard } from '@core/guards/permissions.guard';

const routes: Routes = [
  {
    matcher: (url) => {
      if (!['it', 'en'].includes(url[0]?.path)) {
        return {
          consumed: url,
          posParams: {
            lang: new UrlSegment('it', {}),
          },
        };
      }
      return null;
    },
    loadChildren: () =>
      import('./lang-url/lang-url.module').then((m) => m.LangUrlModule),
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [PermissionsGuard],
    canActivateChild: [PermissionsGuard],
    data: {
      expectedIdProfile: [1],
    },
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./account/account.module').then((m) => m.AccountModule),
    canActivate: [PermissionsGuard],
    canActivateChild: [PermissionsGuard],
    data: {
      expectedIdProfile: [1, 2, 3, 4],
    },
  },
  {
    path: 'user',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'auction',
    loadChildren: () =>
      import('./article/article.module').then((m) => m.ArticleModule),
  },
  {
    path: 'event',
    loadChildren: () =>
      import('./event/event.module').then((m) => m.EventModule),
  },
  {
    path: 'eventnow',
    loadChildren: () =>
      import('./event-now/event-now.module').then((m) => m.EventNowModule),
  },
  {
    path: 'campaign',
    loadChildren: () =>
      import('./campaign/campaign.module').then((m) => m.CampaignModule),
  },
  {
    path: 'promoter',
    loadChildren: () =>
      import('./promoter/promoter.module').then((m) => m.PromoterModule),
  },
  {
    path: 'tags/:tag',
    loadComponent: () =>
      import('./tags-page/tags-page.component').then(
        (m) => m.TagsPageComponent
      ),
  },
  {
    path: 'certificate',
    loadChildren: () =>
      import('./certificate/certificate.module').then(
        (m) => m.CertificateModule
      ),
  },
  {
    path: 'search-result',
    loadChildren: () =>
      import('./search-result/search-result.module').then(
        (m) => m.SearchResultModule
      ),
  },
  {
    path: 'search-result-all',
    loadChildren: () =>
      import('./search-result/search-result.module').then(
        (m) => m.SearchResultModule
      ),
  },
  {
    path: 'search-result-worn',
    loadChildren: () =>
      import('./search-result/search-result.module').then(
        (m) => m.SearchResultModule
      ),
  },
  {
    path: 'search-result-store',
    loadChildren: () =>
      import('./search-result/search-result.module').then(
        (m) => m.SearchResultModule
      ),
  },
  {
    path: 'search-result-signed',
    loadChildren: () =>
      import('./search-result/search-result.module').then(
        (m) => m.SearchResultModule
      ),
  },
  {
    path: 'about-us',
    loadChildren: () =>
      import('./generic-page/generic-page.module').then(
        (m) => m.GenericPageModule
      ),
  },
  {
    path: 'how-works-memorabid',
    loadChildren: () =>
      import('./generic-page/generic-page.module').then(
        (m) => m.GenericPageModule
      ),
  },
  {
    path: 'how-works-auctions',
    loadChildren: () =>
      import('./generic-page/generic-page.module').then(
        (m) => m.GenericPageModule
      ),
  },
  {
    path: 'direct-bidding',
    loadChildren: () =>
      import('./generic-page/generic-page.module').then(
        (m) => m.GenericPageModule
      ),
  },
  {
    path: 'product-types',
    loadChildren: () =>
      import('./generic-page/generic-page.module').then(
        (m) => m.GenericPageModule
      ),
  },
  {
    path: 'payments-shipments',
    loadChildren: () =>
      import('./generic-page/generic-page.module').then(
        (m) => m.GenericPageModule
      ),
  },
  {
    path: 'become-seller',
    loadChildren: () =>
      import('./generic-page/generic-page.module').then(
        (m) => m.GenericPageModule
      ),
  },
  {
    path: 'terms-conditions',
    loadChildren: () =>
      import('./generic-page/generic-page.module').then(
        (m) => m.GenericPageModule
      ),
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('./generic-page/generic-page.module').then(
        (m) => m.GenericPageModule
      ),
  },
  {
    path: 'cookie-policy',
    loadChildren: () =>
      import('./generic-page/generic-page.module').then(
        (m) => m.GenericPageModule
      ),
  },
  {
    path: 'blog',
    loadChildren: () =>
      import('./generic-page/generic-page.module').then(
        (m) => m.GenericPageModule
      ),
  },
  {
    path: 'testimonials',
    loadChildren: () =>
      import('./generic-page/generic-page.module').then(
        (m) => m.GenericPageModule
      ),
  },
  {
    path: 'stripe',
    loadChildren: () =>
      import('./stripe/stripe.module').then((s) => s.StripeModule),
  },
  {
    path: 'createsitemap',
    loadChildren: () =>
      import('./sitemap-creator/sitemap-creator.module').then(
        (s) => s.SitemapCreatorModule
      ),
  },
  {
    path: 'seller',
    loadChildren: () =>
      import('./seller/seller.module').then((s) => s.SellerModule),
  },
  {
    matcher: (url) => {
      if (url.length > 0) {
        let urlPath: string = '';
        url.forEach((segment) => {
          urlPath += `/${segment.path}`;
        });
        return {
          consumed: url,
          posParams: {
            customUrl: new UrlSegment(urlPath, {}),
          },
        };
      }
      return null;
    },
    loadChildren: () =>
      import('./custom-url/custom-url.module').then((m) => m.CustomUrlModule),
    canLoad: [CustomUrlGuard],
  },
  { path: '**', redirectTo: 'home' },
].flatMap((route) => {
  const r1 = { ...route };
  if (r1.path) {
    r1.path = `:lang/${r1.path}`;
    return [r1, route];
  }
  return [route];
});
  ;

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, scrollPositionRestoration: 'enabled', initialNavigation: 'enabledBlocking',  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
